(() => {
  const normalizeText = (value) => (value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const parseMoney = (value) => {
    let raw = (value || '').replace(/[^0-9,.-]/g, '');
    if (!raw) return null;

    const lastComma = raw.lastIndexOf(',');
    const lastDot = raw.lastIndexOf('.');

    if (lastComma > lastDot) {
      raw = raw.replace(/\./g, '').replace(',', '.');
    } else if (lastDot > lastComma) {
      raw = raw.replace(/,/g, '');
    } else {
      raw = raw.replace(',', '.');
    }

    const amount = Number.parseFloat(raw);
    return Number.isFinite(amount) ? amount : null;
  };

  const cleanDescription = (root) => {
    if (!root || root.dataset.velomintCleaned === 'true') return;
    root.dataset.velomintCleaned = 'true';

    // Never expose supplier links on customer-facing product pages.
    root.querySelectorAll('a[href*="bicimarket.com"], a[href*="www.bicimarket.com"]').forEach((link) => {
      const parent = link.closest('p, li');
      const parentText = normalizeText(parent?.textContent);
      if (parent && (parentText.includes('punto 5 de condiciones') || parentText.includes('para mas detalles'))) {
        parent.remove();
      } else {
        link.replaceWith(document.createTextNode(link.textContent || ''));
      }
    });

    // Delivery is already shown next to the price. Remove legacy imported delivery text
    // so the customer never sees two different delivery promises.
    root.querySelectorAll('p, h2, h3, h4, h5, li').forEach((node) => {
      const text = normalizeText(node.textContent);
      const isLegacyDelivery =
        text.includes('existencias ilimitadas para realizar el pedido online') ||
        text.includes('entrega estimada en 5-10 dias') ||
        text.includes('entrega estimada en 5–10 dias') ||
        text === 'disponibilidad y entrega' ||
        text.includes('para mas detalles, consulta el punto 5 de condiciones');

      if (isLegacyDelivery) node.remove();
    });
  };

  const cleanTinySales = () => {
    document.querySelectorAll('.price.price--on-sale, .price.volume-pricing--sale-badge').forEach((priceRoot) => {
      const compareNode = priceRoot.querySelector('.price__sale .price-item--regular');
      const saleNode = priceRoot.querySelector('.price__sale .price-item--sale');
      const compareAt = parseMoney(compareNode?.textContent);
      const current = parseMoney(saleNode?.textContent);

      if (compareAt === null || current === null || compareAt <= current || compareAt <= 0) return;

      const discount = (compareAt - current) / compareAt;
      if (discount >= 0.05) return;

      priceRoot.classList.remove('price--on-sale', 'volume-pricing--sale-badge');
      priceRoot.dataset.velomintTinySale = 'true';

      priceRoot.querySelectorAll('s.price-item--regular').forEach((oldPrice) => {
        oldPrice.style.display = 'none';
      });

      const card = priceRoot.closest('.card-wrapper');
      if (card) {
        card.querySelectorAll('.card__badge .badge').forEach((badge) => {
          const text = normalizeText(badge.textContent);
          if (text.includes('oferta') || text === 'sale') {
            badge.style.display = 'none';
          }
        });
      }
    });
  };

  const cleanAll = () => {
    document.querySelectorAll('.product__description').forEach(cleanDescription);
    cleanTinySales();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanAll, { once: true });
  } else {
    cleanAll();
  }

  document.addEventListener('shopify:section:load', cleanAll);

  const observer = new MutationObserver(() => cleanTinySales());
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
